var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13250",
    "data-name": "Group 13250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.921,
    height: 21.84,
    viewBox: "0 0 20.921 21.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5131",
    "data-name": "Rectangle 5131",
    width: 20.921,
    height: 21.84,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13249",
    "data-name": "Group 13249",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45504",
    "data-name": "Path 45504",
    d: "M78.5.02a5.129,5.129,0,1,1-3.544,8.3A5.138,5.138,0,0,1,78.5.02",
    transform: "translate(-69.35 -0.001)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45505",
    "data-name": "Path 45505",
    d: "M10.111,202.133v7.36a4.211,4.211,0,0,0,.2.807c.083.25.225.471.306.72H1.475a1.805,1.805,0,0,1-1.431-1.44c.085-1.3-.131-2.775,0-4.051.112-1.131,1.459-1.581,2.371-1.959a18.972,18.972,0,0,1,7.7-1.437",
    transform: "translate(0.001 -189.822)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45506",
    "data-name": "Path 45506",
    d: "M190.964,164.9c1.172-.1,2.962-.16,3.839.736a.783.783,0,0,1-.05,1.276c-.681.443-1.017-.422-1.628-.51a10.786,10.786,0,0,0-2.379.058,1.181,1.181,0,0,0-.726.823l-.006,6.834a1.1,1.1,0,0,0,.936.978,14.348,14.348,0,0,0,2.184,0c.627-.082.89-.959,1.637-.49.555.348.349.968-.06,1.337-.9.815-2.6.748-3.762.662a2.629,2.629,0,0,1-2.438-2.393c.121-2.248-.156-4.656,0-6.885a2.615,2.615,0,0,1,2.454-2.422",
    transform: "translate(-176.987 -154.813)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45507",
    "data-name": "Path 45507",
    d: "M235.418,221.19H231.7a1.8,1.8,0,0,1-.249-.116.776.776,0,0,1-.118-1.162,1.322,1.322,0,0,1,.412-.226h3.623c-.186-.29-.761-.644-.818-.982a.758.758,0,0,1,1.274-.727,19.245,19.245,0,0,1,1.938,1.936.769.769,0,0,1,.046,1,21.154,21.154,0,0,1-2.028,2.028.746.746,0,0,1-1.221-.765c.06-.324.675-.693.855-.991",
    transform: "translate(-217.057 -204.504)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBlack);
export default __webpack_public_path__ + "static/media/logout-black.d0278f38660bd6cec0c64ac9fcc1d633.svg";
export { ForwardRef as ReactComponent };